import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { ContactInfo } from "@/components/contact/ContactInfo";
import { InquiryForm } from "@/components/contact/InquiryForm";
import { DirectContactButtons } from "@/components/contact/DirectContactButtons";

export default function ContactUs() {
  return (
    <>
      <Seo
        title="Contact Us"
        description="Contact RKG NATURALS for trade inquiries."
        path="/contact-us"
      />
      <div data-testid="contact-us-page">
        <PageHero
          eyebrow="Contact Us"
          title="Get in Touch with RKG NATURALS"
          subtitle="Whether you are looking for agricultural products, wholesale supplies, export sourcing or import-related requirements, share your details with us."
        />
        <ContactInfo />
        <InquiryForm />
        <DirectContactButtons />
      </div>
    </>
  );
}
